import LeScoopSection from './LeScoopSection';

export default LeScoopSection;
